import React from 'react';

  const HeaderRow = props => (
    <thead>
      <tr>
        {props.children}
      </tr>
    </thead>
  );

export default HeaderRow;
